import { useState, useEffect, useCallback } from 'react';

export default function HomeHero() {
  const [typedText, setTypedText] = useState('');
  const fullText = '官方正版 · 极速下载 · 安全无忧';

  const animate = useCallback(() => {
    let i = 0;
    setTypedText('');
    const timer = setInterval(() => {
      if (i < fullText.length) {
        setTypedText(fullText.slice(0, i + 1));
        i += 1;
      } else {
        clearInterval(timer);
      }
    }, 80);
    return timer;
  }, []);

  useEffect(() => {
    const timer = animate();
    return () => clearInterval(timer);
  }, [animate]);

  return (
    <section className="relative w-full h-[520px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20gaming%20platform%20atmosphere%20with%20warm%20golden%20and%20amber%20toned%20abstract%20geometric%20patterns%20luxurious%20dark%20background%20with%20subtle%20glowing%20particles%20elegant%20gaming%20aesthetic%20clean%20minimal%20design&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="PG国际下载008官方平台"
          title="PG国际下载008 - 官方正版安装包极速下载"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/15 mb-6">
            <i className="ri-verified-badge-fill text-accent-400 text-sm"></i>
            <span className="text-xs md:text-sm text-background-50/90">PG国际008 官方正版认证</span>
          </div>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 font-heading leading-tight mb-4">
            PG国际下载008
          </h1>
          <p className="text-base md:text-lg text-background-50/80 mb-2 font-heading">
            官方正版安装包极速下载
          </p>
          <p className="text-sm md:text-base text-background-50/60 mb-8 h-6">
            {typedText}
            <span className="inline-block w-0.5 h-4 bg-primary-400 ml-0.5 animate-pulse align-middle"></span>
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#download"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-download-2-line text-lg"></i>
              立即免费下载
            </a>
            <a
              href="#features"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 font-medium text-sm md:text-base border border-background-50/20 hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              <i className="ri-arrow-down-line"></i>
              了解更多
            </a>
          </div>
          <div className="flex items-center justify-center gap-6 mt-8">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/20">
                <i className="ri-apple-fill text-background-50 text-sm"></i>
              </div>
              <span className="text-xs text-background-50/70">iOS</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/20">
                <i className="ri-android-fill text-background-50 text-sm"></i>
              </div>
              <span className="text-xs text-background-50/70">Android</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}